import { BackendBaseModel } from '@/utils';
import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../../utils/constants';
import { RESERVED_PROJECT_CODE_MAX_VALUE } from '../constants';

export const ReservedProjectModel = BackendBaseModel.extend({
  code: z.number().int().min(0).max(RESERVED_PROJECT_CODE_MAX_VALUE),
  name: z.string().min(1).max(NAME_MAX_LENGTH),
});

export const ReservedProjectsModel = ReservedProjectModel.array();

export const ReservedProjectUpsertSchema = ReservedProjectModel.pick({
  code: true,
  name: true,
});
